import {
  Pagination, PaginationContent, PaginationEllipsis, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious,
} from "src/components/ui/pagination";
import { useDashboardSurveyList } from "./useDashboardSurveyList";
import { useMemo } from "react";

const PAGE_GROUP_SIZE = 5;
const DashboardSurveyPagination = () => {
  const { data, isFetching, activePage, onPageChanged } = useDashboardSurveyList();
  const { previousPages, nextPages } = useMemo(() => {
    return {
      previousPages: Array.from({ length: Math.min(PAGE_GROUP_SIZE, activePage - 1) }, (_, i) => activePage - i - 1).reverse(),
      nextPages: Array.from({ length: Math.min(PAGE_GROUP_SIZE, (data?.totalPages || 0) - activePage) }, (_, i) => activePage + i + 1),
    };
  }, [data, activePage]);

  if (!data || isFetching) {
    return null;
  }

  if (data.totalObjects === 0) {
    return null;
  }

  const renderPageEntry = (page: number) => {
    return (
      <PaginationItem
        key={page}
        onClick={() => onPageChanged(page)}
      >
        <PaginationLink>
          {page}
        </PaginationLink>
      </PaginationItem>
    );
  };

  const renderPreviousEndcap = () => {
    if (previousPages.length === 0) {
      return null;
    }

    const shouldRenderOne = previousPages[0] > 1;
    const shouldRenderEllipsis = previousPages[0] > 2;

    return (
      <>
        <PaginationItem>
          <PaginationPrevious onClick={() => onPageChanged(activePage - 1)} />
        </PaginationItem>
        {shouldRenderOne && renderPageEntry(1)}
        {shouldRenderEllipsis && (
          <PaginationItem>
            <PaginationEllipsis />
          </PaginationItem>
        )}
      </>
    );
  };

  const renderNextEndcap = () => {
    if (nextPages.length === 0) {
      return null;
    }

    const shouldRenderLast = nextPages[nextPages.length - 1] < data.totalPages;
    const shouldRenderEllipsis = nextPages[nextPages.length - 1] < data.totalPages - 1;

    return (
      <>
        {shouldRenderEllipsis && (
          <PaginationItem>
            <PaginationEllipsis />
          </PaginationItem>
        )}
        {shouldRenderLast && renderPageEntry(data.totalPages)}
        <PaginationItem>
          <PaginationNext onClick={() => onPageChanged(activePage + 1)} />
        </PaginationItem>
      </>
    );
  };

  return (
    <Pagination>
      <PaginationContent>
        {renderPreviousEndcap()}
        {previousPages.map(renderPageEntry)}
        <PaginationItem>
          <PaginationLink isActive>
            {activePage}
          </PaginationLink>
        </PaginationItem>
        {nextPages.map(renderPageEntry)}
        {renderNextEndcap()}
      </PaginationContent>
    </Pagination>
  );
};

export default DashboardSurveyPagination;
